import React, { Component } from 'react';
import Header from '../.././Header';
import Image from '../.././Image';
import classnames from 'classnames';

export default class PetsChamp extends Component {
  // static propTypes = {}
  // static defaultProps = {}
  // state = {}

  render() {
    const { className } = this.props;

    const navLinks = [
      {path: "/projects", title: "Projects"}
    ]

    return (
      <div className={classnames('PetsChamp', className)}>
        <Header links={navLinks} />
        <div className="container">
          <div className="section">
            <div className="section-content">
              <div className="section-header">PetsChamp</div>
              <div className="section-title">Description</div>
              <div className="section-copy">
                <ul>
                  <li><strong>Objective</strong>: Develop a marketplace to connect pet stores and aspiring pet owners</li>
                  <li><strong>Role</strong>: Co-founder, designer and developer</li>
                  <li><strong>Team</strong>: Amanda Lim, Mark Lim</li>
                  <li><strong>Duration</strong>: Sep 2016—Dec 2016 (4 months)</li>
                </ul>
              </div>
              <div className="section-title">Summary</div>
              <div className="section-copy">
                <p>
                  Coming soon.
                </p>
              </div>
              <div className="section-title">Links</div>
              <div className="section-copy">
                <ul>
                  <li><a href="http://www.petschamp.com/">PetsChamp: Puppies, Training and Grooming Tips Online</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Projects/PetsChamp/index.js